export default function ContactSection() {
  return (
    <section id="contact" className="px-4 md:px-6 py-16 md:py-24">
      <div className="max-w-2xl mx-auto text-center">
        <h2 className="font-heading font-bold text-3xl md:text-4xl text-foreground-950">
          Abstract Data
        </h2>
        <h3 className="mt-2 font-heading font-semibold text-xl text-foreground-700">
          Your Premier Choice for Reserved GPUaaS
        </h3>
        <p className="mt-6 text-sm text-foreground-500">
          contact@abstractdata.ai
        </p>
      </div>
    </section>
  );
}